import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "vehicle-grid-page" }
const _hoisted_2 = { class: "vehicle-grid-card" }
const _hoisted_3 = { class: "vehicle-grid-card__header" }
const _hoisted_4 = { class: "vehicle-grid-title" }
const _hoisted_5 = { class: "vehicle-grid-title__text" }
const _hoisted_6 = { class: "vehicle-grid-card__body" }
const _hoisted_7 = { class: "vehicle-status-stack" }
const _hoisted_8 = {
  key: 0,
  class: "vehicle-status-pill vehicle-status-pill--info"
}
const _hoisted_9 = { class: "vehicle-main-cell" }
const _hoisted_10 = { class: "fw-bold fs-2 reduced-margin-bottom" }
const _hoisted_11 = {
  key: 0,
  class: "fs-6 reduced-margin-bottom"
}
const _hoisted_12 = {
  key: 1,
  class: "fs-6 reduced-margin-bottom"
}
const _hoisted_13 = {
  key: 2,
  class: "fs-6 reduced-margin-bottom"
}
const _hoisted_14 = { class: "fs-6 reduced-margin-bottom" }
const _hoisted_15 = {
  key: 3,
  class: "fs-6 reduced-margin-bottom"
}
const _hoisted_16 = {
  key: 4,
  class: "fs-6 reduced-margin-bottom"
}
const _hoisted_17 = { class: "vehicle-driver-cell" }
const _hoisted_18 = { class: "vehicle-driver-cell__name" }
const _hoisted_19 = { class: "vehicle-driver-cell__cards" }
const _hoisted_20 = {
  key: 0,
  class: "vehicle-muted"
}
const _hoisted_21 = ["href"]
const _hoisted_22 = ["src", "alt"]
const _hoisted_23 = ["title", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vehicle_modal = _resolveComponent("vehicle-modal")!
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxColumnFixing = _resolveComponent("DxColumnFixing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "vehicle-grid-title__icon" }, [
            _createElementVNode("i", { class: "fa fa-truck" })
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.$t('components.vehicles.tabs.vehicles')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_vehicle_modal, {
          ref: "vehicleModalRef",
          onEmittedRefreshGrid: _ctx.refreshGrid
        }, null, 8, ["onEmittedRefreshGrid"]),
        _createVNode(_component_DxDataGrid, {
          ref: _ctx.dataGridRef,
          "allow-column-reordering": true,
          "allow-column-resizing": true,
          "data-source": _ctx.store,
          "hover-state-enabled": true,
          "remote-operations": _ctx.remoteOperations,
          "show-borders": true,
          "show-column-lines": true,
          scrolling: { mode: 'standard', useNative: true },
          class: "vehicle-grid",
          height: "auto",
          onContentReady: _ctx.onContentReady
        }, {
          "status-cell-template": _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_7, [
              (data.data.sent_geo)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "fa fa-globe" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('components.vehicles.dataGrids.sentgeo')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                class: _normalizeClass([_ctx.statusClass(data.data.device?.etoll), "vehicle-status-pill"])
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass([_ctx.statusIconClass(data.data.device?.etoll), "fa"])
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('components.vehicles.dataGrids.etoll')), 1)
              ], 2),
              _createElementVNode("span", {
                class: _normalizeClass([_ctx.statusClass(data.data.device?.has_garmin), "vehicle-status-pill"])
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass([_ctx.statusIconClass(data.data.device?.has_garmin), "fa"])
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('components.vehicles.dataGrids.garmin')), 1)
              ], 2),
              _createElementVNode("span", {
                class: _normalizeClass([_ctx.statusClass(data.data.device?.has_tacho), "vehicle-status-pill"])
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass([_ctx.statusIconClass(data.data.device?.has_tacho), "fa"])
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('components.vehicles.dataGrids.tachograph')), 1)
              ], 2)
            ])
          ]),
          "vehicle-cell-template": _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.getVehicleDisplayName(data.data)), 1),
              (data.data.registration && data.data.vars?.name)
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(data.data.registration), 1))
                : _createCommentVNode("", true),
              (data.data.device?.imei)
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                    _cache[2] || (_cache[2] = _createElementVNode("b", null, "IMEI:", -1)),
                    _createTextVNode(" " + _toDisplayString(data.data.device.imei), 1)
                  ]))
                : _createCommentVNode("", true),
              (data.data.vin)
                ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.$t('components.vehicles.dataGrids.vinNumber')) + ":", 1),
                    _createTextVNode(" " + _toDisplayString(data.data.vin), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_14, [
                _createElementVNode("b", null, _toDisplayString(_ctx.$t('components.vehicles.dataGrids.tankCapacity')) + ":", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.getTankCapacity(data.data)) + " L ", 1)
              ]),
              (data.data.vars?.phone)
                ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.$t('components.vehicles.dataGrids.phoneNumber')) + ":", 1),
                    _createTextVNode(" " + _toDisplayString(data.data.vars.phone), 1)
                  ]))
                : _createCommentVNode("", true),
              (data.data.vars?.virtual_odometer)
                ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.$t('components.vehicles.dataGrids.virtualOdometer')) + ":", 1),
                    _createTextVNode(" " + _toDisplayString(data.data.vars.virtual_odometer) + " km ", 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          "driver-cell-template": _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "fa fa-user" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.getDriverName(data.data)), 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "fa fa-credit-card" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.getDriverCards(data.data)), 1)
              ])
            ])
          ]),
          "location-cell-template": _withCtx(({ data }) => [
            (!data.data.dataLastCoordinates)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, "—"))
              : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: _ctx.mapsUrl(data.data.dataLastCoordinates),
                  target: "_blank",
                  rel: "noopener"
                }, _toDisplayString(_ctx.addrCache[data.data.device.imei]
                  || `${Number(data.data.dataLastCoordinates.lat).toFixed(6)}, ${Number(data.data.dataLastCoordinates.lng).toFixed(6)}`), 9, _hoisted_21))
          ]),
          "icon-cell-template": _withCtx(({ data }) => [
            _createElementVNode("img", {
              src: _ctx.getIconSrc(data.data.vars?.icon_id),
              alt: `Icon ${data.data.registration}`,
              class: "vehicle-map-icon"
            }, null, 8, _hoisted_22)
          ]),
          "edit-cell-template": _withCtx(({ data }) => [
            _createElementVNode("button", {
              title: _ctx.$t('components.vehicles.dataGrids.edit'),
              class: "vehicle-icon-button",
              type: "button",
              onClick: ($event: any) => (_ctx.openEditModal(data))
            }, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("i", { class: "fa fa-edit" }, null, -1)
            ]))], 8, _hoisted_23)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_DxHeaderFilter, { visible: false }),
            _createVNode(_component_DxPaging, {
              "page-index": 0,
              "page-size": 25
            }),
            _createVNode(_component_DxPager, {
              "allowed-page-sizes": [10, 20, 25, 50, 100],
              "show-info": true,
              "show-navigation-buttons": true,
              "show-page-size-selector": true
            }),
            _createVNode(_component_DxFilterRow, { visible: true }),
            _createVNode(_component_DxColumnFixing, { enabled: true }),
            _createVNode(_component_DxColumn, {
              "allow-hiding": false,
              caption: _ctx.$t('components.vehicles.dataGrids.vehicle'),
              "filter-operations": _ctx.allowedOperations,
              "cell-template": "vehicle-cell-template",
              "data-field": "vehicleLabel",
              width: "16.6%"
            }, null, 8, ["caption", "filter-operations"]),
            _createVNode(_component_DxColumn, {
              caption: _ctx.$t('components.vehicles.dataGrids.driver'),
              "filter-operations": _ctx.allowedOperations,
              "cell-template": "driver-cell-template",
              "data-field": "driverFullName",
              width: "20.6%"
            }, null, 8, ["caption", "filter-operations"]),
            _createVNode(_component_DxColumn, {
              "allow-filtering": false,
              "allow-sorting": false,
              caption: _ctx.$t('components.vehicles.dataGrids.status'),
              "cell-template": "status-cell-template",
              "css-class": "vehicle-grid__status-column",
              width: "16.6%"
            }, null, 8, ["caption"]),
            _createVNode(_component_DxColumn, {
              "allow-filtering": false,
              "allow-sorting": false,
              caption: _ctx.$t('components.vehicles.dataGrids.icon'),
              "cell-template": "icon-cell-template",
              "css-class": "vehicle-grid__icon-column",
              width: "16.6%"
            }, null, 8, ["caption"]),
            _createVNode(_component_DxColumn, {
              "allow-filtering": false,
              caption: _ctx.$t('components.vehicles.dataGrids.location'),
              "cell-template": "location-cell-template",
              "css-class": "vehicle-grid__location-column",
              width: "16.6%"
            }, null, 8, ["caption"]),
            (_ctx.adminOrBoss)
              ? (_openBlock(), _createBlock(_component_DxColumn, {
                  key: 0,
                  "allow-filtering": false,
                  "allow-hiding": false,
                  "allow-sorting": false,
                  caption: _ctx.$t('components.vehicles.dataGrids.edit'),
                  "cell-template": "edit-cell-template",
                  "css-class": "vehicle-grid__edit-column",
                  width: "12.6%"
                }, null, 8, ["caption"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data-source", "remote-operations", "onContentReady"])
      ])
    ])
  ]))
}